import "@babel/polyfill";
import "objectFitPolyfill";
import "intersection-observer";
import smoothscroll from "smoothscroll-polyfill";

import "./remove";

// kick off the polyfill!
smoothscroll.polyfill();
